import React from 'react';

import classes from 'components/shared/pills/Pill.module.scss';
import { ENGAGEMENT_TYPE } from 'constants/constants';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';

const EngagementPill = ({ item }) => {
  const metricClass =
    item?.type === ENGAGEMENT_TYPE.internal
      ? 'number__internal'
      : 'number__external';

  const tooltip = (source) => {
    return (
      <Tooltip className='gne-tooltip'>
        <span className='text text__x-small'>Source: {source}</span>
      </Tooltip>
    );
  };
  return (
    <OverlayTrigger overlay={tooltip(item?.source)}>
      <div
        className={`${classes.pill} ${classes['pill-metric']} text-center animate__animated animate__fadeIn`}>
        <span className={`${classes.number} ${classes[metricClass]}`}>
          {item?.count}
        </span>
        <span>{item?.engagement}</span>
      </div>
    </OverlayTrigger>
  );
};
export default EngagementPill;
